import {Box, Spinner, Text} from '@chakra-ui/react';
import colorAlpha from 'color-alpha';
import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import axios from "axios";

const More = ({authorId, data}) => {
    const [otherPodcasts, setOtherPodcasts] = useState(undefined)
    const {slug} = useParams();
    useEffect(() => {
        const abortController = new AbortController();
        const fetchPodcastsData = async () => {
            if(data?.coauthors[0]?.slug) {
                const otherPods = await axios.get(`/wp-admin/admin-ajax.php?action=get_insights&insights_start=0&insights_include_podcasts=only&author_slug=${data?.coauthors[0]?.slug}&exclude_post_slug=${slug}`, {signal: abortController.signal}).then(resp => {
                    return resp.data.items;
                });
                setOtherPodcasts(otherPods)
            } else {
                setOtherPodcasts([])
            }
        }
        fetchPodcastsData()
        return () => {
            abortController.abort();
        }
    }, [authorId, slug])
    if (!otherPodcasts) {
        return (
            <Box my={20} width="100%" textAlign="center">
                <Spinner color='blue.600' size='xl'/>
            </Box>
        )
    }
    if (otherPodcasts?.length < 1) {
        return <></>
    }
    return (
        <Box mb={'80px'}>
            <Text mb={'40px'} fontSize={'32px'} lineHeight={'32px'} letterSpacing={'-1px'}>
                More episodes from {data?.coauthors[0]?.name?.split(' ')[0]}
            </Text>
            <Box>
                {otherPodcasts?.slice(0, 3).map((item) => (
                    <PostsItem key={item.ID} {...item} />
                ))}
            </Box>
        </Box>
    );
};

export default More;

const PostsItem = (props) => {
    const {post_title, post_excerpt, url} = props;
    return (
        <Link to={`${url}`}>
            <Box
                paddingBottom={'23px'}
                borderBottom={`1px solid ${colorAlpha('#A1B6E5', 0.4)}`}
                mb={'20px'}
            >
                <Text
                    fontWeight={500}
                    mb={'10px'}
                    color={'brand.700'}
                    fontSize={'24px'}
                    lineHeight={'32px'}
                    noOfLines={1}
                >
                    {post_title}
                </Text>
                <Text fontSize={'18px'} lineHeight={'21.6px'} noOfLines={3}>
                    {post_excerpt}
                </Text>
            </Box>
        </Link>
    );
};
